import React, { useContext } from 'react';

import ChartColorsProvider from 'contextProviders/ChartColorsProvider';
import ChartColorsContext from 'contexts/ChartColorsContext';
import { useChartPalette } from 'contexts/ChartPaletteContext';

// Stacked charts (stackedArea/stackedBar) consume ChartColorsContext. A canvas
// (ReportCanvas) already supplies one provider shared across all its cards, so
// only mount a fresh provider when one isn't already in scope — preserving
// consistent per-term colours across cards while covering standalone renders
// (gadget config/preview, widget gallery, etc.). A chart with its own palette
// always gets its own provider, handing out the palette's colours.
const EnsureChartColorsProvider = ({ children }: { children: JSX.Element }) => {
  const { hasProvider } = useContext(ChartColorsContext);
  const { colors, isCustom } = useChartPalette();
  if (isCustom) {
    return (
      <ChartColorsProvider colors={colors}>{children}</ChartColorsProvider>
    );
  }
  return hasProvider ? (
    children
  ) : (
    <ChartColorsProvider>{children}</ChartColorsProvider>
  );
};

export default EnsureChartColorsProvider;
